export default "__VITE_ASSET__4ea1bc7e__"